'use client';

import { isSome } from '@crocodille/util';
import { useEffect, useRef } from 'react';

/**
 * Given a value, returns only last value passing the `accept` predicate.
 * Initial value given will be `undefined` if it doesn't pass the predicate.
 *
 * @param value Value to "lag"
 * @param accept Custom predicate to accept or reject the value
 *
 * @returns "Lagging" value
 */
export function useLagging<V>(
  value: V,
  accept: (value: V) => boolean = isSome,
): V | undefined {
  const laggingData = useRef<V | undefined>(undefined);

  useEffect(() => {
    if (accept(value)) {
      laggingData.current = value;
    }
  }, [value, accept]);

  return !accept(value) ? laggingData.current : value;
}
